import React, {useEffect} from 'react';
import './App.scss';
import AppHeader from "../../components/AppHeader/AppHeader";
import AppFooter from "../../components/AppFooter/AppFooter";
import ShopPage from "../ShopPage/ShopPage";
import ItemPage from "../ItemPage/ItemPage";
import MainPage from "../MainPage/MainPage";
import ConcertsPage from "../ConcertsPage/ConcertsPage";
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import NotFoundPage from "../../components/NotFoundPage/NotFoundPage";
import CartPage from "../CartPage/CartPage";
import PrivacyPolicyPage from "../PrivacyPolicyPage/PrivacyPolicyPage";
import PublicOffering from "../PrivacyPolicyPage/PublicOffering";

function AppContent() {
    const location = useLocation();
    const pageTitles = {
        '/': 'Магазин | эпатажность',
        '/shop/:id': 'Товар | эпатажность',
        '/events': 'События | эпатажность',
        '/about': 'Контакты | эпатажность',
        '/cart': 'Корзина | эпатажность',
        '/privacy-policy': 'Корзина | ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ',
        '/public-offering': 'Корзина | ПУБЛИЧНАЯ ОФЕРТА',
        '404': 'Страница не найдена | эпатажность',
    };

    useEffect(() => {
        const path = location.pathname;
        let title = pageTitles['404'];

        if (path === '/') {
            title = pageTitles['/'];
        } else if (path.startsWith('/shop/')) {
            title = pageTitles['/shop/:id'];
        } else if (path === '/events') {
            title = pageTitles['/events'];
        } else if (path === '/about') {
            title = pageTitles['/about'];
        }  else if (path === '/cart') {
            title = pageTitles['/cart'];
        } else if (path === '/privacy-policy') {
            title = pageTitles['/privacy-policy'];
        } else if (path === '/public-offering') {
            title = pageTitles['/public-offering'];
        }

        document.title = title;
    }, [location.pathname]);

    return (
        <div>
            {!location.pathname.includes('404') && <AppHeader />}
            <Routes>
                <Route path="/" element={<ShopPage />} />
                <Route path="/shop/:id" element={<ItemPage />} />
                <Route path="/events" element={<ConcertsPage />} />
                <Route path="/about" element={<MainPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/public-offering" element={<PublicOffering />} />
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
            {!location.pathname.includes('404') && <AppFooter />}
        </div>
    );
}

function App() {
    return (
        <Router>
            <AppContent />
        </Router>
    );
}

export default App;